"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelIterator = void 0;
var tslib_1 = require("tslib");
var search_1 = require("@devexpress/utils/lib/utils/search");
var full_chunk_and_run_info_1 = require("./full-chunk-and-run-info");
var ModelIterator = (function (_super) {
    tslib_1.__extends(ModelIterator, _super);
    function ModelIterator(subDocument, ignoreHiddenRuns) {
        var _this = _super.call(this, -1, null, -1, null, 0) || this;
        _this.subDocument = subDocument;
        _this.chunks = subDocument.chunks;
        _this.ignoreHiddenRuns = ignoreHiddenRuns;
        return _this;
    }
    ModelIterator.prototype.setPositionByFullRunInfo = function (runInfo) {
        if (this.run && this.getAbsolutePosition() == runInfo.getAbsolutePosition())
            return;
        this.chunkIndex = runInfo.chunkIndex;
        this.chunk = runInfo.chunk;
        this.runs = this.chunk.textRuns;
        this.runIndex = runInfo.runIndex;
        this.run = runInfo.run;
        this.charOffset = runInfo.charOffset;
        if (this.ignoreHiddenRuns && this.run.getCharacterMergedProperties().hidden)
            this.moveToNextRun();
    };
    ModelIterator.prototype.setPosition = function (pos) {
        if (this.run && this.getAbsolutePosition() == pos)
            return;
        this.chunkIndex = search_1.SearchUtils.normedInterpolationIndexOf(this.chunks, function (c) { return c.startLogPosition.value; }, pos);
        this.chunk = this.chunks[this.chunkIndex];
        var runOffset = pos - this.chunk.startLogPosition.value;
        this.runs = this.chunk.textRuns;
        this.runIndex = search_1.SearchUtils.normedInterpolationIndexOf(this.runs, function (r) { return r.startOffset; }, runOffset);
        this.run = this.runs[this.runIndex];
        this.charOffset = runOffset - this.run.startOffset;
        if (this.ignoreHiddenRuns && this.run.getCharacterMergedProperties().hidden)
            this.moveToNextRun();
    };
    ModelIterator.prototype.moveToNextChar = function () {
        if (this.charOffset + 1 < this.run.getLength()) {
            this.charOffset++;
            return true;
        }
        return this.moveToNextRun();
    };
    ModelIterator.prototype.moveToPrevChar = function () {
        if (this.charOffset > 0) {
            this.charOffset--;
            return true;
        }
        return this.moveToPrevRun();
    };
    ModelIterator.prototype.moveToNextRun = function () {
        if (this.runIndex + 1 < this.runs.length) {
            this.charOffset = 0;
            this.runIndex++;
            this.run = this.runs[this.runIndex];
            if (this.ignoreHiddenRuns && this.run.getCharacterMergedProperties().hidden)
                return this.moveToNextRun();
            return true;
        }
        if (this.chunkIndex + 1 < this.chunks.length) {
            this.charOffset = 0;
            this.runIndex = 0;
            this.chunkIndex++;
            this.chunk = this.chunks[this.chunkIndex];
            this.runs = this.chunk.textRuns;
            this.run = this.runs[this.runIndex];
            if (this.ignoreHiddenRuns && this.run.getCharacterMergedProperties().hidden)
                return this.moveToNextRun();
            return true;
        }
        return false;
    };
    ModelIterator.prototype.moveToPrevRun = function () {
        if (this.runIndex > 0) {
            this.runIndex--;
            this.run = this.runs[this.runIndex];
            this.charOffset = this.run.getLength() - 1;
            if (this.ignoreHiddenRuns && this.run.getCharacterMergedProperties().hidden)
                return this.moveToPrevRun();
            return true;
        }
        if (this.chunkIndex > 0) {
            this.chunkIndex--;
            this.chunk = this.chunks[this.chunkIndex];
            this.runs = this.chunk.textRuns;
            this.runIndex = this.runs.length - 1;
            this.run = this.runs[this.runIndex];
            this.charOffset = this.run.getLength() - 1;
            if (this.ignoreHiddenRuns && this.run.getCharacterMergedProperties().hidden)
                return this.moveToPrevRun();
            return true;
        }
        return false;
    };
    ModelIterator.prototype.clone = function () {
        var newIterator = new ModelIterator(this.subDocument, this.ignoreHiddenRuns);
        newIterator.chunks = this.chunks;
        newIterator.chunk = this.chunk;
        newIterator.chunkIndex = this.chunkIndex;
        newIterator.runs = this.runs;
        newIterator.run = this.run;
        newIterator.runIndex = this.runIndex;
        newIterator.charOffset = this.charOffset;
        return newIterator;
    };
    return ModelIterator;
}(full_chunk_and_run_info_1.FullChunkAndRunInfo));
exports.ModelIterator = ModelIterator;
